<div class="container-fluid" style="padding-top: 8px; padding-right:5px; ">

    <div style="display: inline;block-size: 10%;">

        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 10px 5px 15px 5px;">

            <div class="col-md-4 col-sm-6" style="display: inline-block; padding-left: 0px; ">

                <h2 class="ng-binding header lblHeader newHeader" style="font-size: 25px;">
                    Item Transaction Log 
                </h2>
            </div>

            <div class="col-md-8 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
                <!-- <span class="search">
                    <span class="fa fa-search"></span>
                    <input class="form-control brdrColor bgWhite" ng-model="search.term" placeholder="Search" matInput
                        (keyup)="applyFilter($event)" #input
                        style="text-align: left; display: inline-block; padding-left: 35px !important; border-radius: 25px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 35px !important;"
                        type="text">
                </span> -->
                <span class="search">
                    <span class="fa fa-search"></span>
                    <input class="form-control brdrColor brdrRadius3" ng-model="search.term" placeholder="Search" matInput
                      (keyup)="applyFilter($event)" #input
                      style="text-align: left;display: inline-block; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 33px !important;"
                      type="text">
                  </span>
                <!-- 
                <span class="btn btn-green" style="cursor: pointer;line-height: 22px; padding: 5px 11px;" title="Refresh">
                <span>
                    <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
                </span>
                </span> -->

                <span (click)="exportToExcelActivities()" class="btn btn-orange brdrRadius3"
                    style="margin-left: 10px; cursor: pointer; line-height: 21px; padding: 4px 9px;"
                    title="Export to Excel" *ngIf="dataSource.data.length > 0">
                    <span>
                        <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
                    </span>
                </span>

                <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
                    <span class="btn-darkBlue brdrRadius3"
                        style="font-size: 13px; display: inline-block; padding: 3px 12px 4px; margin-left: 10px;"
                        (click)="backBtn()">
                        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                    </span>
                </div>

            </div>
        </div>
    </div>


    <div class="col-md-12 col-xs-12 col-sm-12" style="display:inline-block; margin-bottom:10px; padding: 0px;">
        <div class="row">
            <!-- change month and date filter  and item and transaction-->
            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-right: 0px;padding-left: 7px; display: flex;">
                <!-- <span class="label fntSz {{period == 1 ? 'bz-orgBtn-lb-active' : 'bz-orgBtn-lb'}}" id="thisMonth" style="cursor: pointer; padding: 3px 12px 5px; line-height: 20px; margin-right: 10px;" (click)="typeFilter(1)">Month</span> -->
                <div class="padLft15" style="display:inline-block">
                    <div style="display: inline-block; margin-left: 0px; margin-right: 10px;">
                        <select class="formCtlFltr form-control bgwhite" style="box-shadow: none; cursor: pointer;" [(ngModel)]="monthDisplay"
                            (change)="trasYearChange()">
                            <option *ngFor="let i of months;">{{i.display}}</option>
                        </select>
                    </div>
                </div>
                <!-- <span class="label fntSz {{period == 2 ? 'bz-orgBtn-lb-active' : 'bz-orgBtn-lb'}}" id="other" style="cursor: pointer; margin-right: 10px; padding: 3px 12px 5px; line-height: 20px;" (click)="typeFilter(2)">Other</span> -->
                <div style="cursor: pointer; display: flex; align-items: center; justify-content: center; height: 30px; flex: 0 0 auto; margin-right: 5px;" (click)="showDateRangePicker()">
                    <span style="font-size: 17px; color: #15304a;"><i class="fa fa-calendar"></i></span>
                </div>
                <div *ngIf="dateFilter.showDateRange" style="display:inline-block ;padding-left: 0px;padding-top:2px;margin-right: 5px;margin-left: 5px;">
                    <span style="font-size: 13px !important; color: #daa520 !important;">
                        <input [max]="dateFilter.fromMaxDT" [min]="dateFilter.fromMinDT" matInput [matDatepicker]="picker" [(ngModel)]="startDate" (click)="picker.open()"
                            class="formCtlFltr  form-control bgwhite" (ngModelChange)="fn_ChangeDate()"
                            style="color:#555 !important; display: inline-block; width: 80px; background: #FFF; cursor: pointer; font-size: 12px;text-indent: 5px;vertical-align: middle;">
                        <!-- <mat-datepicker-toggle matSuffix [for]="picker" style="vertical-align: middle; color: #daa520 !important"></mat-datepicker-toggle> -->
                        <mat-datepicker #picker></mat-datepicker>
                    </span>

                    <span style="font-size: 13px; margin-left: 10px;">to</span>
                    <span class="dtpicker" style="margin-left: 10px;font-size: 12px !important; color: #daa520 !important;">
                        <input [min]="dateFilter.toMinDT" [max]="dateFilter.toMaxDT" matInput [matDatepicker]="Newdate" [(ngModel)]="endDate" (click)="Newdate.open()"
                            class="formCtlFltr  form-control bgwhite" (ngModelChange)="fn_ChangeDate()"
                            style="color:#555 !important;display: inline-block; width: 80px; background: #FFF; cursor: pointer;font-size: 13px;text-indent: 5px;vertical-align: middle;">
                        <!-- <mat-datepicker-toggle matSuffix [for]="Newdate" style="vertical-align: middle; color:#daa520 !important"></mat-datepicker-toggle>   -->
                        <mat-datepicker #Newdate></mat-datepicker>
                    </span>
                </div>
                <div style="display: inline-block; margin-left: 10px;">
                <!-- <div style="display: inline-block;">
                    <span style="color: #15304a; margin-right: 10px"><i class="fa fa-exchange"></i></span>
                </div> -->
                    <div style="display: inline-block;">
                        <select class="formCtlFltr form-control bgwhite" style="box-shadow: none; cursor: pointer;" [(ngModel)]="transType.id"
                            (change)="ChangeTransType()">
                            <option *ngFor="let s of transactionType" value="{{s.id}}">{{s.type}}</option>
                        </select>
                    </div>
                    <!-- <div style="display: inline-block;">
                        <span style="color: #15304a; margin-right: 10px; margin-left: 10px;"><i class="zmdi zmdi-file"></i></span>
                    </div> -->
                    <div style="display: inline-block; margin-left: 10px;">
                    <mat-form-field class="example-full-width font13 item-select-field" style="width: 300px;" appearance="outline">
                        <input matInput placeholder="Select Item" [matAutocomplete]="autoItem" [formControl]="itemCtrl">
                        <mat-autocomplete #autoItem="matAutocomplete" [displayWith]="displayFn" (optionSelected)="ChangeItem()">
                            <mat-option *ngFor="let item of filteredItems | async" [value]="item">
                                {{item.ItemName}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                </div>
            </div>
        </div>



        <!-- <span class="label greenBadge fntSz"
            style="display:none;padding: 6px 10px; margin-right: 10px; line-height: 23px; float: right;"
            *ngIf="dataSource.data.length > 0">
            Current Stock: {{countData[0].CurrentQty}}</span>

        <span class="label tealBadge fntSz"
            style="display:none;padding: 6px 10px; margin-right: 10px; line-height: 23px; float: right;"
            *ngIf="dataSource.data.length > 0">
            Value:{{countData[0].Value}}</span>

        <span class="label blueBadge fntSz"
            style="display:none;padding: 6px 10px; margin-right: 10px; line-height: 23px; float: right;"
            *ngIf="dataSource.data.length > 0">
            Opening Qty:{{countData[0].OpeningQty}}</span> -->
    </div>


    

    <div style="margin: 0px 10px 10px 7px;" *ngIf="dataSource.data.length > 0">
        <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow brdrRadius3">
            <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px;">
                <ng-container matColumnDef="Date" style="cursor: pointer;">

                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                        <label>Date</label>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.Date | todayTommorow}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="transTypeName" style="cursor: pointer;">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                        <label>Type</label>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.transTypeName}}

                    </td>
                </ng-container>

                <ng-container matColumnDef="XnNo" style="cursor: pointer;">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                        <label>Transaction No.</label>
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.XnNo}} </td>
                </ng-container>

                <ng-container matColumnDef="relativeName" style="cursor: pointer;">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                        <label>Other Details</label>
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.relativeName ? element.relativeName : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="NewoutStoreName" style="cursor: pointer;">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                        <label>Store</label>
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.NewoutStoreName ? element.NewoutStoreName :
                        element.inStoreName}} </td>
                </ng-container>

                <ng-container matColumnDef="IQty" style="cursor: pointer;">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header  style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 26px; width: 8%;">
                        <label>In Qty</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right;padding-right: 51px!important;">
                        <div style="text-align: right; padding-right: 25px;">
                            {{element.IQty }} </div>
                        <!-- {{element.IQty}} -->
                     </td>
                </ng-container>
<!-- 
                <ng-container matColumnDef="OQty" style="cursor: pointer;">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="width: 6%;">
                        <label tyle="cursor: pointer">Out Qty</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right;padding-right: 51px!important;">
                        <div style="text-align: right; padding-right: 11px;">
                            {{element.OQty}} </div>    
                    </td>
                </ng-container> -->
                <ng-container matColumnDef="OQty" style="cursor: pointer;">
                    <th  class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 26px; width: 8%;">
                        <label style="cursor: pointer;font-size: 13px;">Out Qty</label>
                       
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right;padding-right: 51px!important;">
                        <div style="text-align: right; padding-right: 20px;">
                          {{element.OQty }} </div>
                    </td>
                </ng-container>

             
                <ng-container matColumnDef="Unit" style="cursor: pointer;">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 26px; width: 6%;">
                    <label style="cursor: pointer;font-size: 13px;">Unit</label>
                    
                </th>
                <td mat-cell *matCellDef="let element">
                    <div style="text-align: left; padding-right: 11px;">
                        <!-- {{element.UNm}} -->
                        {{element.Unit}}
                     </div>
                </td>
            </ng-container>
                    
            <ng-container matColumnDef="XnByUser" style="cursor: pointer;">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Executive</label>
                </th>
                <td mat-cell *matCellDef="let element"> {{element.XnByUser ? element.XnByUser : '-' }} </td>
            </ng-container>


                <ng-container matColumnDef="XnNotes" style="cursor: pointer;">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                        <label tyle="cursor: pointer">Notes</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: left;cursor: pointer;"> <i
                            style="color:#E1A730; margin: 5px;" class="fa fa-sticky-note" *ngIf="element.XnNotes"
                            ></i>{{element.XnNotes ? element.XnNotes : '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Action">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>

                    </th>
                    <td mat-cell *matCellDef="let element; let i = index" style="text-align: center;">
                        <div class="budge2 btn lableBtnDarkBlue padLeft5 hvrInfo btnBottom brdrRadius3"
                            (click)="printTranjection(element.XnID)" title="Print"
                            style="padding: 2px 9px !important;display: inline-block; text-align: center;margin-top: 5px;"
                            *ngIf="element.XnTypeID==4 || element.XnTypeID==9 || element.XnTypeID==1 || element.XnTypeID==5 || element.XnTypeID==2 || element.XnTypeID==7 || element.XnTypeID==12 || element.XnTypeID==13">
                            <i aria-hidden="true" class="zmdi zmdi-print"></i>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
            </table>


            <!-- Angular 8 pagination -->
            <mat-paginator [pageSizeOptions]="[10, 20, 30,100]" showFirstLastButtons class="brdrRadius3">
            </mat-paginator>
        </div>

    </div>

    <div *ngIf="dataSource.data.length == 0">
        <div class="no-record-badge" style="margin-left:7px">No records found.</div>
    </div>

</div>